module.exports = __webpack_public_path__ + "static/img/ill1.7992095.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/envi/ill1.png
// module id = AzVW
// module chunks = 1